import { useEffect } from "react";

export default function Reservierung() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "//static.resmio.com/static/de/widget.js#id=480grad-neapolitan-pizza-x-pianobar&height=800&width=800&fontSize=2rem";
    script.async = true;

    const firstScript = document.getElementsByTagName("script")[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    }

    // Optional: Cleanup (entferne Script bei Unmount)
    return () => {
      script.remove();
    };
  }, []);

return (
  <section
    style={{
      textAlign: "center",
      fontSize: "2rem", // gesamter Text größer
      lineHeight: "1.6",   // bessere Lesbarkeit
    }}
  >
    <h1>Reservieren</h1>
    <div id="resmio-480grad-neapolitan-pizza-x-pianobar"></div>
    {/*<p>Reservierungen auch gerne telefonisch</p>
    <div className="buttoncontainer">
            <button
              onClick={() => alert("Anruf ist derzeit nicht möglich.")}
              className="hero-btn"
            >
              Anrufen
            </button>
            {/*<button
              onClick={() => (window.location.href = "tel:017670349355")}
              className="hero-btn"
            >
              Anrufen
            </button>
    </div>*/}
  </section>
);
}